import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Alert from 'flarum/common/components/Alert';
import Button from 'flarum/common/components/Button';
let temporarilyHidden = false;
export default class UpdateAlert extends Component {
  view() {
    const {
      user
    } = app.session;
    if (temporarilyHidden || !user || !user.fofTermsPoliciesHasUpdate()) {
      return null;
    }
    const mustAccept = user.fofTermsPoliciesMustAccept();
    const hasOnlyOptionalUpdates = !mustAccept && user.fofTermsPoliciesHasUpdate();
    const message = hasOnlyOptionalUpdates ? app.translator.trans('fof-terms.forum.update-alert.can-accept-optional-message') : mustAccept ? app.translator.trans('fof-terms.forum.update-alert.must-accept-message') : app.translator.trans('fof-terms.forum.update-alert.can-accept-message');
    return m(Alert, {
      containerClassName: "container",
      dismissible: !mustAccept,
      ondismiss: () => {
        temporarilyHidden = true;
        m.redraw();
      },
      controls: [m(Button, {
        className: "Button Button--link",
        onclick: () => {
          app.modal.show(() => import(/* webpackChunkName: 'forum/components/AcceptPoliciesModal', webpackMode: 'lazy-once' */ './AcceptPoliciesModal'));
        }
      }, app.translator.trans('fof-terms.forum.update-alert.review'))]
    }, message);
  }
}
flarum.reg.add('fof-terms', 'forum/components/UpdateAlert', UpdateAlert);